var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1918 2.38128C11.1918 1.98679 11.5116 1.66699 11.9061 1.66699H17.6204C18.0148 1.66699 18.3346 1.98679 18.3346 2.38128V8.09556C18.3346 8.49005 18.0148 8.80985 17.6204 8.80985C17.2259 8.80985 16.9061 8.49005 16.9061 8.09556V4.10572L8.60162 12.4102C8.32267 12.6891 7.87041 12.6891 7.59146 12.4102C7.31252 12.1312 7.31252 11.679 7.59146 11.4L15.8959 3.09556H11.9061C11.5116 3.09556 11.1918 2.77577 11.1918 2.38128ZM4.28702 5.00033C3.62953 5.00033 3.09654 5.53332 3.09654 6.1908V15.7146C3.09654 16.3721 3.62953 16.9051 4.28702 16.9051H13.8108C14.4683 16.9051 15.0013 16.3721 15.0013 15.7146V11.9051C15.0013 11.5106 15.3211 11.1908 15.7156 11.1908C16.1101 11.1908 16.4299 11.5106 16.4299 11.9051V15.7146C16.4299 17.1611 15.2573 18.3337 13.8108 18.3337H4.28702C2.84056 18.3337 1.66797 17.1611 1.66797 15.7146V6.1908C1.66797 4.74434 2.84056 3.57175 4.28702 3.57175H8.09654C8.49103 3.57175 8.81083 3.89155 8.81083 4.28604C8.81083 4.68053 8.49103 5.00033 8.09654 5.00033H4.28702Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon2);
export default __webpack_public_path__ + "static/media/link-icon-2.5344d88a973da5fcc86449a89e89cc9d.svg";
export { ForwardRef as ReactComponent };